import React, { useRef, useState, useEffect } from "react"
import { useAuthDataContext } from "../../../../../_providers/Auth"
import Api from "../../../../../_helpers/Api"
import Modal from "./modals/Integrations"
import Skeleton from "react-loading-skeleton"
import { trans } from "@/_providers/Translation"

function Integrations(props) {
  const auth = useAuthDataContext()

  const modalRef = useRef(null)

  const [state, setState] = useState({
    loading: true,
    data: [],
    update: false,
  })

  useEffect(() => {
    loadSettings()
  }, [state.update])

  const loadSettings = () => {
    Api.get("partners/settings/all?id=" + auth.user().partner_id)
      .then((res) => {
        setState((prev) => ({
          ...prev,
          loading: false,
          data: res.data,
        }))
      })
      .catch(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }))
      })
  }

  const handleUpdate = () => {
    setState((prev) => ({
      ...prev,
      update: new Date().getTime(),
    }))
  }

  const showModal = () => {
    let modal = modalRef.current

    modal.show(state.data)

    modal.onSave(() => {
      handleUpdate()

      if (typeof props.handleRefresh === "function") {
        props.handleRefresh()
      }
    })
  }

  return (
    <div style={{ width: "100%" }}>
      <div className="head">
        <h3
          style={{
            marginBottom: 0,
          }}
        >
          {trans('headings.integrations')}
        </h3>
        <button className="button button-small button-edit" onClick={showModal}>
          {trans("buttons.editAction")}
        </button>
      </div>
      <hr />

      {state.loading ? (
        <Skeleton height={35} count={2} />
      ) : (
        <>
          <Modal ref={modalRef} />
          <div className="alert info">
            {trans('messages.aircallWebhook')}
            <br />
            <br />
            {trans('messages.linkToThePlatform')}: https://dashboard.aircall.io
            <br />
            URL: https://service.eus.tech/aircall-webhook
          </div>
          <div className="table-scroller">
            <table className="settings">
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>
                    <b>Aircall Token</b>
                  </td>
                  <td>
                    {state.data.aircall_token
                      ? state.data.aircall_token
                      : trans("labels.notSpecified")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <div className="alert info">
            {trans('messages.aswoApiGet')}
          </div>
          <div className="table-scroller">
            <table className="settings">
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>
                    <b>ASWO API Key</b>
                  </td>
                  <td>
                    {state.data.aswo_api_key
                      ? state.data.aswo_api_key
                      : trans("labels.notSpecified")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  )
}

export default Integrations
